import { useAppContext } from "../../contexts";
import {useCookies, useValidatePath} from "../../hooks";
import {useState, useEffect} from "preact/compat";

export const useLocationPickerModal = () => {
    // Cookie to check if modal has already been displayed in a previous access
    const [shouldDisplayModal, setShouldDisplayModal] = useCookies('location_modal', true);

    // Retrieves the flag to check if user is at a special path route.
    // The modal can't be displayed if so.
    const {isSpecialPath} = useValidatePath();

    const { isLocationPickerOpen, setIsLocationPickerOpen } = useAppContext(); 

    const handleClose = () => {
        setIsLocationPickerOpen(false);
        console.log('Location picker closed');
        window.location.reload(); // check the need
    } 

    // Effect to check whether the modal should be displayed or not
    useEffect(() => {
        if (shouldDisplayModal && !isSpecialPath) {
            // Displays the modal after a 2 seconds delay
            const timer = setTimeout(() => {
                setIsLocationPickerOpen(true);
                // TODO: the expire property isn't working as intended.
                //  The value being set is the default one.
                setShouldDisplayModal(false, 7);

                clearTimeout(timer);
            }, 2000);
        }
    }, [shouldDisplayModal, isSpecialPath]);

    return {
        isOpen: isLocationPickerOpen,
        handleClose
    }
}
